export default __webpack_public_path__ + "static/media/es.674197c4.svg";